"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getBrowser() {
    // if not in a browser, assume we're in a test, return a dummy
    if (typeof window === 'undefined') {
        //@ts-ignore
        return {};
    }
    //@ts-ignore
    return require('webextension-polyfill');
}
exports.browser = getBrowser();
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/webextension-polyfill-ts/dist/generated/index.js
// module id = /p2K
// module chunks = 16